var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconBnpl40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_9010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0091 36.0174C28.5726 36.0174 35.5147 29.0753 35.5147 20.5118C35.5147 11.9483 28.5726 5.00616 20.0091 5.00616C11.4455 5.00616 4.50342 11.9483 4.50342 20.5118C4.50342 29.0753 11.4455 36.0174 20.0091 36.0174Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.999 36.0073C15.4776 35.772 11.7447 34.1974 8.80037 31.2836C5.85605 28.3697 4.42463 24.7757 4.50611 20.5016C5.10364 20.5016 6.29541 20.5016 8.0814 20.5016C8.06867 21.7739 7.94343 24.9514 11.3939 28.8031C14.155 31.8973 18.0045 32.429 19.999 32.429C19.9905 33.2175 19.9905 34.4102 19.999 36.0073Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0083 36.0073C24.5297 35.772 28.2626 34.1974 31.207 31.2836C34.1513 28.3697 35.5827 24.7757 35.5012 20.5016C34.9037 20.5016 33.7119 20.5016 31.9259 20.5016C31.9387 21.7739 32.0639 24.9514 28.6134 28.8031C25.8524 31.8973 22.0028 32.429 20.0083 32.429C20.0168 33.2175 20.0168 34.4102 20.0083 36.0073Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0083 4.99597C24.5297 5.23124 28.2626 6.80581 31.207 9.71968C34.1513 12.6336 35.5827 16.2275 35.5012 20.5016C34.9037 20.5016 33.7119 20.5016 31.9259 20.5016C31.9387 19.2294 32.0639 16.0518 28.6134 12.2001C25.8524 9.10589 22.0028 8.5742 20.0083 8.5742C20.0168 7.78575 20.0168 6.59301 20.0083 4.99597Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0091 36.0174C28.5726 36.0174 35.5147 29.0753 35.5147 20.5118C35.5147 11.9483 28.5726 5.00616 20.0091 5.00616C11.4455 5.00616 4.50342 11.9483 4.50342 20.5118C4.50342 29.0753 11.4455 36.0174 20.0091 36.0174Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 32.4291C26.586 32.4291 31.9261 27.089 31.9261 20.5016C31.9261 13.9143 26.586 8.57422 19.9987 8.57422C13.4114 8.57422 8.07129 13.9143 8.07129 20.5016C8.07129 27.089 13.4114 32.4291 19.9987 32.4291Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.77 17.321H15.228V26.8629H24.77V17.321Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3842 16.5258C22.3842 15.2083 21.3162 14.1403 19.9988 14.1403C18.6813 14.1403 17.6133 15.2083 17.6133 16.5258",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.999 32.429V36.0072",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.999 4.99597V8.5742",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49316 20.5016H8.07139",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9263 20.5016H35.5045",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_9010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconBnpl40);
export default __webpack_public_path__ + "static/media/pictogramBeaconBNPL40.673afabf74543ff7f809740edae3ccaa.svg";
export { ForwardRef as ReactComponent };